
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { setModalsData, TModalsState } from "../../../api/store/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { AdminFormFieldSubmit } from "../../../components/admin/formFields";

type ModalRestoreDefaultConfirmationProps = {
   handleRestore: () => void;
};

const ModalRestoreDefaultConfirmation: FC<ModalRestoreDefaultConfirmationProps> = ({
    handleRestore,
}) => {
  const { t: tMain } = useTranslation();
  const { t } = useTranslation("translation", {
    keyPrefix: "camera.dashboard.management.camera_settings",
  });
  const modalsState: TModalsState = useSelector(
    (state: any) => state.commonReducer.modals
  );
  const dispatch = useDispatch();
  const hideModal = () => {
    dispatch(setModalsData({ ...modalsState, showRestoreDefaultConfirmation: false }));
  };

  const handleSubmit = () => {
    hideModal();
    handleRestore();
  };

  if (modalsState.showRestoreDefaultConfirmation === false) return null;

  return (
    <>
      <div className="fixed w-full h-screen top-0 left-0 bg-modal-overlay z-overlay" onClick={hideModal}></div>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none z-modal">
        <div className="relative my-6 mx-auto max-w-[calc(100vw-4rem)] w-[480px] z-modal">
          <form
            className="p-8 bg-white grid grid-cols-6 gap-6 rounded-3xl shadow-2xl"
            onSubmit={handleSubmit}
          >
            <h2 className="col-span-6 text-3xl font-bold text-heading-black">
              {t("restore_settings")}
            </h2>
            <p className="col-span-6 mt-0 leading-relaxed text-gray-500">
              {t("restore_settings_description")}
            </p>
            <AdminFormFieldSubmit
              label={tMain("yes")}
              type="button"
              variant="primary"
              onClick={handleSubmit}
            />

            <AdminFormFieldSubmit
              label={tMain("no")}
              type="button"
              variant="danger-transparent"
              onClick={hideModal}
            />
          </form>
        </div>
      </div>
    </>
  );
};

export default ModalRestoreDefaultConfirmation;
